<div class="d-flex min-vh-100 py-3 bg-body">
  <div class="left-side-bar d-flex flex-column">
    <div class="px-3 mb-3">
      <img class="logo" [src]="logoUrl()" alt="Insolution" />

      <div class="text-center text-break fw-bold pt-1 fs-5">{{ currentTenantName() }}</div>
    </div>

    <div class="px-3 flex-grow-1 d-flex flex-column">
      <ng-content select="[slot=left-sidebar]"></ng-content>
    </div>
  </div>

  <div class="flex-grow-1 d-flex flex-column main-content">
    <div class="px-3 mb-3">
      <ng-content select="[slot=header]"></ng-content>
    </div>

    <div class="flex-grow-1 px-3">
      <ng-content select="[slot=main]"></ng-content>
    </div>
  </div>
</div>
